import MonoBehavior from "../lib/MonoBehavior";
import Bullet from "../scripts/Bullet";
import CTFFlag from "../scripts/CTFFlag";
import DaggerMineBehavior from "../scripts/DaggerMineBehavior";
import Explosion from "../scripts/Explosion";
import { FlakShard } from "../scripts/FlakShard";
import GameManager from "../scripts/GameManager";
import GravityWellBehavior from "../scripts/GravityWellBehavior";
import HealingFieldBehavior from "../scripts/HealingFieldBehavior";
import HomingRocketBehavior from "../scripts/HomingRocketBehavior";
import Player from "../scripts/Player";

export const ScriptTypeMap: Record<string, typeof MonoBehavior> = {
    "PLAYER": Player,
    "GAME_MANAGER": GameManager,
    "EXPLOSION": Explosion,
    "GRAVITY_WELL": GravityWellBehavior,
    "BULLET": Bullet,
    "ROCKET": HomingRocketBehavior,
    "FLAK_SHARD": FlakShard,
    "DAGGER_MINE": DaggerMineBehavior,
    "HEALING_FIELD": HealingFieldBehavior,
    "CTF_FLAG": CTFFlag
};